import React from 'react';

const BOMPage = React.lazy(() => import('pages/FakeOrder/pages/BOMPage'));
const BOMAdd = React.lazy(() => import('pages/FakeOrder/pages/BOMAdd'));

const FakeOrderRoute = [
  {
    path: '/bom',
    exact: true,
    name: 'BOM hàng',
    component: BOMPage,
    // function: 'CRM_STAFF',
  },
  {
    path: '/bom/add',
    exact: true,
    name: 'Thêm mới BOM hàng',
    component: BOMAdd,
  },
  {
    path: '/bom/detail/:id',
    exact: true,
    name: 'Chi tiết BOM hàng',
    component: BOMAdd,
  },
  {
    path: '/bom/edit/:id',
    exact: true,
    name: 'Chỉnh sửa BOM hàng',
    // function: 'PRICEQUOTE_EDIT',
    component: BOMAdd,
  },
];

export default FakeOrderRoute;
